import { absoluteApiFilePreviewUrl } from './api'

/** 전산 표시명 ↔ orgs.name 매칭용 (공백·대소문자 무시) */
export function normalizeInsurerKey(name) {
  const key = String(name || '').trim().replace(/\s+/g, '').toLowerCase()
  if (key === '현대해상화재' || key === '현대해상화재보험' || key === '현대해상보험') {
    return '현대해상'
  }
  return key
}

function insurerLogoUrl(org) {
  if (!org) return null
  if (org.claimBrandLogoFileId) return absoluteApiFilePreviewUrl(org.claimBrandLogoFileId)
  if (org.logoUrl) return org.logoUrl
  if (org.logoImageUrl) return org.logoImageUrl
  if (org.logoFileId) return absoluteApiFilePreviewUrl(org.logoFileId)
  if (org.fileId) return absoluteApiFilePreviewUrl(org.fileId)
  return null
}

function insurerLogoMatchKeys(name) {
  const raw = String(name || '').trim()
  const baseKey = normalizeInsurerKey(raw)
  const categoryStrippedKey = normalizeInsurerKey(
    raw
      .replace(/(펫보험|펫|배상책임보험|배상책임)$/u, '')
      .replace(/(petinsurance|pet|liabilityinsurance|liability)$/iu, ''),
  )
  return [...new Set([baseKey, categoryStrippedKey].filter(Boolean))]
}

/**
 * 보험사 전산 표의 회사명(displayName)과 동일한 이름의 INSURER 조직을 찾아
 * 청구 브랜드 로고(있으면) 또는 logoFileId 미리보기 URL을 반환합니다.
 * @param {string} displayName insurerSystemsData 행의 name (예: 삼성화재)
 * @param {Array<object>} orgOptions GET /orgs/options 응답 배열
 * @returns {string|null}
 */
export function resolveInsurerLogoUrlFromOrgOptions(displayName, orgOptions) {
  if (!displayName || !Array.isArray(orgOptions)) return null
  const keys = insurerLogoMatchKeys(displayName)
  const insurers = orgOptions.filter((o) => o && String(o.type) === 'INSURER')
  for (const key of keys) {
    const match = insurers.find((o) => normalizeInsurerKey(o.name) === key && insurerLogoUrl(o))
    const logoUrl = insurerLogoUrl(match)
    if (logoUrl) return logoUrl
  }
  return null
}
